module.exports = __webpack_public_path__ + "resources/img/img_dvision4.af434196eadd7fcbf93d6e98e1ad2b01.png";